<script lang="ts">
import { AppTagComponent } from "./app-tag.ts";
export default AppTagComponent;
</script>
<template>
    <p-tag class="app-tag">
        <slot></slot>
    </p-tag>
</template>
